export default __webpack_public_path__ + "static/media/24.ad7927aa.jpg";